export const ActiveJobsTypes = {
  GET_ACTIVE_JOBS_LIST: 'GET_ACTIVE_JOBS_LIST',
  CLEAR_ACTIVE_JOBS_LIST: 'CLEAR_ACTIVE_JOBS_LIST',
  GET_COMPLETED_JOBS_LIST: 'GET_COMPLETED_JOBS_LIST',
  CLEAR_COMPLETED_JOBS_LIST: 'CLEAR_COMPLETED_JOBS_LIST',
};
